import React from 'react';
import classes from './Header.module.scss';
import { Button, ButtonProps, Col, ColProps, Layout, Row } from 'antd';
import cn from 'classnames';
import { ArrowLeftOutlined } from '@ant-design/icons';

type RenderBackButton = (
  title: string,
  defaultElement: React.FunctionComponent<any>
) => React.ReactNode;

type BaseHeaderProps = {
  title?: string;
  backButton?: boolean | RenderBackButton | React.ReactNode;
  onBack?: () => void;
  backButtonProps?: React.ComponentProps<typeof Button>;
  layout?: 'vertical' | 'horizontal';
  leftColProps: ColProps;
  rightColProps: ColProps;
  right?: React.ReactNode;
};

const BackButton: React.FC<
  {
    title: BaseHeaderProps['title'];
  } & Partial<ButtonProps>
> = (props) => {
  const { title, children, className, onClick, ...rest } = props;
  return (
    <Button
      className={cn(classes.backButton, className)}
      icon={<ArrowLeftOutlined />}
      type="text"
      onClick={onClick}
      {...rest}
    >
      {children || (
        <span className={classes['backButton__title']}>{title}</span>
      )}
    </Button>
  );
};

const BaseHeader: React.FC<BaseHeaderProps> = (props) => {
  const {
    layout,
    onBack,
    leftColProps,
    rightColProps,
    title,
    right,
    backButtonProps,
    backButton = false
  } = props;

  const renderBackButton = () => {
    if (typeof backButton === 'function') {
      return backButton(title, BackButton);
    }
    if (typeof backButton === 'boolean' && backButton) {
      return <BackButton onClick={onBack} title={title} {...backButtonProps} />;
    }
    if (typeof backButton !== 'undefined') {
      return backButton;
    }
    return null;
  };

  return (
    <Layout.Header
      className={cn(classes.header, {
        [classes.vertical]: layout === 'vertical'
      })}
    >
      <Row
        gutter={[8, 8]}
        wrap
        justify={'space-between'}
        style={{ width: '100%' }}
      >
        <Col {...leftColProps}>
          {typeof backButton === 'boolean' && backButton ? (
            renderBackButton()
          ) : (
            <span className={classes['header__title']}>{title}</span>
          )}
        </Col>
        <Col {...rightColProps}>{right}</Col>
      </Row>
    </Layout.Header>
  );
};

export default BaseHeader;
